// extracted by mini-css-extract-plugin
var _1 = "ra-box-tabs-active";
var _2 = "ra-box-tabs";
var _3 = "ra-box-tabs-controls";
var _4 = "ra-box-tabs-controls-init";
var _5 = "ra-box-tabs-icon";
var _6 = "ra-box-tabs-item-content";
var _7 = "ra-box-tabs-pane";
var _8 = "ra-box-tabs-pane-wrapper";
var _9 = "ra-box-tabs-title";
export { _1 as "tabsActiveCls", _2 as "tabsCls", _3 as "tabsControlsCls", _4 as "tabsControlsInitCls", _5 as "tabsIconCls", _6 as "tabsItemContentCls", _7 as "tabsPaneCls", _8 as "tabsPaneWrapperCls", _9 as "tabsTitleCls" }
